import React from 'react'
import styles from "./popup.module.css";
import FAQ from "../../FAQ"
import Faq from '../../FAQ';

const popUp = (props) => {

    return (
        <div className={styles.container}>
            {/* <Faq /> */}
            <h2 style={{ color:"#94A7AE"}}>1) Jūsų nustatytos nuolaidos</h2>
            <h2 style={{ color:"#94A7AE"}}>2) Dovanų kuponai</h2>
            <h2 style={{ color:"#94A7AE", marginBottom: "3rem"}}>3) arba kita svarbi informacija</h2>
        </div>

    )
}

export default popUp